// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".FTECoachmark__FTECoachmarkContainer___viBRi{bottom:10px;position:absolute;right:10px}", ""]);
// Exports
exports.locals = {
	"FTECoachmarkContainer": "FTECoachmark__FTECoachmarkContainer___viBRi"
};
module.exports = exports;
